<template>
  <div class="panel-in-tab">
    <div style="height: 10px"></div>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="addEdit(null)">新增</el-button>
      </template>
      <el-table
        :data="tableData"
        border
        :height="maxTableHeight + 42"
        ref="table"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        :span-method="objectSpanMethod"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column label="合并统计" prop="statisticalName"></el-table-column>
        <el-table-column label="平台名称" prop="platformName"></el-table-column>
        <el-table-column label="店铺简称" prop="storeName"></el-table-column>
        <el-table-column label="店铺名称" prop="storeNumeFull"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="addEdit(scope.row)">编辑</el-link>
            <el-link type="danger" :underline="false" @click="del(scope.row)" style="margin-left: 10px">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
    <add-edit
      :visible.sync="isShowAddEdit"
      v-if="isShowAddEdit"
      :tableDataDialog="tableDataDialog"
      :reportOptions="reportOptions"
      :storeList="storeList"
      :rowData="rowData"
      @success="onSearch"
    />
  </div>
</template>

<script>
import addEdit from "./add&edit.vue";
import axios from "@/utils/axiosInstance";
import tableMixin from '@/utils/tableMixin';

export default {
  components: { addEdit },
  mixins: [tableMixin],
  data() {
    return {
      tableData: [],
      reportOptions: ["是", "否"],
      updateText: false,
      isShowAddEdit: false,
      loading: false,
      spanIndex: 0,
      spanArr: [],
      rowData: {},
      searchFormData: {},
      tableDataDialog: [],
      queryCriteria: [],
      storeList: [],
      reportName: "prePlanPlatStoreConfig",
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  mounted() {
    this.init();
    this.getStoreList();
  },
  methods: {
    updateAdd(row) {
      row.flag = !row.flag;
      if (!row.flag) {
        this.handleSelectChange(row);
      }
    },
    cancel() {
      this.updateText = false;
      this.init();
    },
    onSearch() {
      this.queryCriteria = [];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: 999,
        pageNum: 1,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.list || [];
            if (this.tableData && this.tableData.length) {
              this.computeSpanData(this.tableData);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      console.log(val);
    },
    async addEdit(row) {
      this.rowData = row ? { ...row } : row;
      this.tableDataDialog = row ? this.tableData.filter((v) => v.statisticalName == row.statisticalName) : [];
      this.isShowAddEdit = true;
    },
    async del(row) {
      let data = row ? this.tableData.filter((v) => v.statisticalName == row.statisticalName) : [];
      let status = await this.$confirm(`是否确认删除？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      this.$q.preSalePlan.platCategoryDel({ data: data }).then((res) => {
        if (res.success) {
          this.$message.success(`删除成功`);
        } else {
          this.$message.error(`删除失败`);
        }
        this.onSearch();
      });
    },
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1);
        this.spanIndex = 0;
      } else {
        if (data[index].statisticalName === data[index - 1].statisticalName) {
          this.spanArr[this.spanIndex] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.spanIndex = index;
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex == 0 || columnIndex > 3) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1,
        };
      }
    },
    getStoreList() {
      this.$q.preSalePlan.planGetStoreNameOptions().then((res) => {
        if (res.success && res.data && res.data.storeNameOptions.length) {
          this.storeList = res.data.storeNameOptions.filter(v => v.name != '全平台');
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

>>> .el-input--mini .el-input__inner
  width 64px
</style>
